export const toPx = (value: number | string): string =>
  typeof value === 'number' ? `${value}px` : value;
